import type { FC } from 'react';

import type { CompaniesIndustry } from '@xing-com/crate-common-graphql-types';

import { IndustryCard } from '../../../../components/industry-card/industry-card';
import { SectionContainer } from '../../../../components/section-container/section-container';
import { useCompaniesIndustries } from '../../../../hooks/use-companies-industries';
import { createCompaniesIndustries } from '../../../../models/industry';
import { ROUTES } from '../../../../routes';
import * as Styled from './companies-by-industries-section.styles';

const LIMIT = 6;

export const CompaniesByIndustriesSection: FC = () => {
  const { data, loading } = useCompaniesIndustries({ limit: LIMIT });

  const collection = (data?.companiesIndustries?.collection ??
    []) as CompaniesIndustry[];
  const industriesCollection = createCompaniesIndustries(collection);

  return (
    <SectionContainer
      title="CP_INDUSTRIES_SECTION_TITLE"
      subtitle="CP_INDUSTRIES_SECTION_SUBLINE"
      linkUri={ROUTES.industries}
    >
      <Styled.GridIndustries>
        {loading && (
          <>
            {Array.from({ length: LIMIT }).map((_, index) => (
              <IndustryCard.Skeleton key={index} />
            ))}
          </>
        )}
        {industriesCollection?.map((item) => (
          <IndustryCard key={item.id} item={item} />
        ))}
      </Styled.GridIndustries>
    </SectionContainer>
  );
};
